export default __webpack_public_path__ + "static/media/Instagram.8b0c7fc0.svg";